import { createAsyncThunk } from '@reduxjs/toolkit';
import { Cars, } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindCar } from './interface';

export const findCar = createAsyncThunk(
  'cars/findCar',
  async (values: FindCar, { rejectWithValue }) => {
    try {
      const response = await Cars.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCar = createAsyncThunk(
  'cars/getCar',
  async (values: { id: string }, { rejectWithValue }) => {
    try {
      const response = await Cars.get(values.id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);